import { Component, OnInit, Input } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { Preferences } from '@capacitor/preferences';
import { DataService } from 'src/app/services/data.service';
import { ToastService } from 'src/app/services/toast.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';

@Component({
  selector: 'app-enterlotpassword',
  templateUrl: './enterlotpassword.page.html',
  styleUrls: ['./enterlotpassword.page.scss'],
})
export class EnterlotpasswordPage implements OnInit {
  @Input() LotNameID: string; // This will come from the modal props
  password: string = '';
  @Input() permitType
  constructor(
    private errorHandler: ErrorHandlerService,
    private modalCtrl: ModalController,
    private dataSRV: DataService,
    private toastSRV:ToastService,
    private loadingCtrl: LoadingController,
  ) { }

  ngOnInit() { 
    if(this.permitType=='waitlist'){
      this.permitType='standard'
    }
  }
  
  async checkPassword() {
    var lotNameID = this.LotNameID
    if (this.LotNameID && this.password) {
      var loading = await this.loadingCtrl.create({
    });
    await loading.present();
      // Make API call to verify the password
      this.dataSRV.postData(`permits/${this.permitType}/password/${lotNameID}/verify`, { lot_password: this.password }).subscribe({
        next: async (response:any) => {
          if (response?.code == 'return-success-with-redirect') {
           this.dataSRV.storeData(`passwordEntered`, 
            {
              lotNameID: lotNameID,
              passwordEntered:true
            })

            // Dismiss the modal and return success
            this.modalCtrl.dismiss({ passwordEntered: true });
            this.toastSRV.presentToast(response.message)
            await loading.dismiss()
          } else if(response?.code == 'return-success-with-back') {
            this.password=''
            await loading.dismiss()
            this.toastSRV.presentErrorToast(response.message)       
          }
        },
        error:err=>{
          this.password=''
          this.errorHandler.displayErrorMessage(err, true)
        }
      }
       
      );
    }
  }

  closeModal() {
    this.modalCtrl.dismiss({ passwordEntered: false });
  }
}
